<template>
  <div class="content-title">
    <div>
      <span class="title-kh-1">》</span><span class="title-kh-2">》</span><span>{{title}}</span>
    </div>
    <div class="right-text" v-if="rightText">
      {{rightText}}
    </div>
    <div class="right-text" v-if="searchInput">
      <el-input style="width: 10rem" v-model="inputValue" size="mini" placeholder="" icon="search"></el-input>
    </div>
    <div v-if="actions" class="title-menus">
      <a href="javascript:;" v-for="action in actions">
        <i class="iconfont" :class="action.icon" @click="clickMenu(action.key)"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'actions', 'rightText', 'searchInput', 'clearNum'],
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    inputValue (value) {
      this.$emit('searchInputChange', value)
    },
    clearNum (value) {
      this.inputValue = ''
    }
  },
  methods: {
    clickMenu (key) {
      this.$emit('clickMenu', key)
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.title-menus {
  margin-right: 0.5rem;
  i {
    font-size: 1.3rem;
    margin-left: 1rem;
    color: #fff;
  }
}
.content-title {
  font-size: 1.13em;
  color: @line-color;
  color: rgba(255, 255, 255, 1);
  height: 2.5em;
  min-height: 2.5em;
  background-color: #0b5591;
  display: flex;
  border-top-left-radius: @content-border-radius-size;
  border-top-right-radius: @content-border-radius-size;
  align-items: center;
  justify-content: space-between;
  padding-left: 2.5em;
  .title-kh-1 {
    color: rgba(255, 255, 255, 0.5);
    letter-spacing: -0.71em;
  }
  .title-kh-2 {
    color: rgba(255, 255, 255, 1);
    letter-spacing: -2px;
  }
  i {
    padding-right: 10px;
  }
  .right-text {
    font-size: 0.8rem;
    margin: 0 1.5rem 0 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// ContentTitle.vue?632801f2